import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showRank?: boolean;
}

export default function ComicCard({ comic, showRank = false }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 漫画封面`}
          title={`${comic.title} - ${comic.tags.join('、')}漫画推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {showRank && comic.rank <= 3 && (
          <div className="absolute top-2 left-2 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-sm font-bold">
            {comic.rank}
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs">
          {comic.status}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1 text-secondary-500 text-xs">
            <i className="ri-star-fill"></i>
            <span className="font-bold">{comic.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-foreground-900 text-sm line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1 line-clamp-1">{comic.author}</p>
        <div className="flex items-center gap-2 mt-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(comic.views / 10000).toFixed(0)}万
          </span>
          <span>{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}